/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:35:58AM]
Permissions to update outside the main branch: [false]
*/

import {
    useCondition,
    ValidatedDatePicker,
    ValidatedDatePickerProps,
} from '@finbeat/react-toolkit';
import { useGeneralSettingsContext } from 'providers/GeneralSettingsProvider';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import { FieldValues } from 'react-hook-form';
import DatePickerHeaderNova from '../BODatePicker/Headers/DatePickerHeader.nova';
import { useMemo } from 'react';

export const BOValidatedDatePicker = <
    TFieldValues extends FieldValues = FieldValues,
    AllowNullReturn extends boolean = false,
>(
    props: Omit<ValidatedDatePickerProps<TFieldValues, AllowNullReturn>, 'displayDateFormat'>
) => {
    const {
        dateTimeFormat,
        timeFormat,
        dateFormat: systemDisplayFormat,
        designType,
    } = useGeneralSettingsContext();

    const renderCustomHeader = useCondition(designType, { nova: NovaHeader }, undefined);

    const displayDateFormat = useMemo(() => {
        if (props.dateOnly) return systemDisplayFormat;
        return props.timeOnly ? timeFormat : dateTimeFormat;
    }, [props, systemDisplayFormat, timeFormat, dateTimeFormat]);

    return (
        <ValidatedDatePicker<TFieldValues, AllowNullReturn>
            {...props}
            displayDateFormat={displayDateFormat}
            renderCustomHeader={renderCustomHeader}
        />
    );
};

const NovaHeader = (props: ReactDatePickerCustomHeaderProps) => <DatePickerHeaderNova {...props} />;
